import { API_VERSION, API_HOST } from '../config/env';

export { API_VERSION };

export const API_BASE_URL = `${API_HOST}${API_VERSION}/`;

export const LOGIN_URL = `${API_BASE_URL}auth/token/`;
export const REFRESH_TOKEN_URL = `${API_BASE_URL}auth/token/refresh/`;
export const PASSWORD_RESET = `${API_BASE_URL}auth/password-reset/`;
export const PASSWORD_RESET_CONFIRM = `${API_BASE_URL}auth/password-reset-confirm/`;
export const PASSWORD_RESET_VALIDATE = `${API_BASE_URL}auth/password-reset-validate/`;
export const ACTIVATE_RESET = `${API_BASE_URL}auth/activate-reset/`;
export const ACTIVATE_CONFIRM = `${API_BASE_URL}auth/activate-confirm/`;
export const ACTIVATE_VALIDATE = `${API_BASE_URL}auth/activate-validate/`;
export const PASSWORD_CHANGE = `${API_BASE_URL}auth/password-change/`;
export const LOGOUT_URL = `${API_BASE_URL}auth/logout/`;

export const DASHBOARD_SUMMARY_URL = `${API_BASE_URL}dashboard/`;

export const FLEET_CARS_URL = `${API_BASE_URL}cars/`;
export const FLEET_DRIVERS_URL = `${API_BASE_URL}drivers/`;
export const FLEET_CARS_DRIVERS = `${API_BASE_URL}fleet/cars-drivers/`;
export const FLEET_CARS_CONFIGURATION_AVAILABLE = `${API_BASE_URL}cars-configuration-available/`;
export const FLEET_CAR_MAKERS = `${API_BASE_URL}car-makers/`;
export const FLEET_CONFIGURE_CARS = `${API_BASE_URL}configure-cars/`;
export const CAR_DETAILS_URL = (carId: string | number) => `${FLEET_CARS_URL}${carId}/`;
export const DRIVER_DETAILS_URL = (driverId: string | number) => `${FLEET_DRIVERS_URL}${driverId}/`;
export const CAR_SERVICE_ORDERS_URL = (carId: string | number) => `${FLEET_CARS_URL}${carId}/service_orders/`;
export const DRIVER_SERVICE_ORDERS_URL = (driverId: string | number) => `${FLEET_DRIVERS_URL}${driverId}/service_orders/`;

export const OFFER_URL = `${API_BASE_URL}offer/`;

export const SERVICE_ORDERS_URL = `${API_BASE_URL}service-orders/`;
export const SERVICE_ORDERS_EXPORT_URL = `${API_BASE_URL}service-orders/export/`;
export const ORDER_DETAILS_URL = (orderId: string | number) => `${SERVICE_ORDERS_URL}${orderId}/`;

export const TRANSACTIONS_URL = `${API_BASE_URL}transactions/`;
export const TRANSACTIONS_EXPORT_URL = `${API_BASE_URL}transactions/export/`;

export const DOCUMENTS_URL = `${API_BASE_URL}documents/account-documents`;

export const ACCOUNT_URL = `${API_BASE_URL}account/`;
export const PROFILE_URL = `${API_BASE_URL}profile/`;

// One-off payments
export const PAYMENTS_ONE_OFF_CREATE_URL = `${API_BASE_URL}payments/one-off/create/`;
export const PAYMENTS_ONE_OFF_IS_FINISHED_URL = (paymentId: string | number) => `${API_BASE_URL}payments/one-off/is_finished/${paymentId}/`;
